import {  createContext } from "react";

//export const konekcija = "http://localhost:8000/";
export const konekcija = "https://backend.ginder.in.rs/";


export const konekcijaContext = createContext<any>(null);
